import * as React from 'react'
export const HelpCenterIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={85} height={84} fill="none" {...props}>
    <g filter="url(#a)">
      <circle cx={42.5} cy={42} r={22} fill="#fff" />
    </g>
    <g clipPath="url(#b)">
      <path
        fill="#E12468"
        stroke="#E12468"
        d="M42.909 52h-9.742C31.964 52 31 51.04 31 49.875v-15.75c0-1.164.965-2.125 2.167-2.125h6.504c.398 0 .78.157 1.062.435l4.829 4.75c.281.276.438.65.438 1.033v1.054a7.979 7.979 0 0 0-.333.119v-.516H40.5c-.836 0-1.5-.665-1.5-1.469v-5.093h-5.833a1.822 1.822 0 0 0-1.834 1.812v15.75c0 1.01.828 1.813 1.834 1.813h9.447c.095.106.194.21.295.312Zm2.237-13.438h.643l-.159-.623a1.124 1.124 0 0 0-.312-.54l-4.826-4.75a1.158 1.158 0 0 0-.54-.302l-.619-.152v5.211c0 .645.532 1.157 1.167 1.157h4.646Zm2.687 10.5h.5V46.75h-.5a.164.164 0 0 1-.166-.156c0-.078.068-.157.166-.157h.667c.098 0 .167.08.167.157v2.468h.5c.098 0 .166.08.166.157a.164.164 0 0 1-.166.156h-1.334a.164.164 0 0 1-.166-.156c0-.078.068-.157.166-.157Zm5.834-2.468c0-1.354-.547-2.65-1.516-3.605A5.204 5.204 0 0 0 48.5 41.5a5.204 5.204 0 0 0-3.65 1.49 5.057 5.057 0 0 0-1.517 3.604c0 1.353.547 2.65 1.516 3.604a5.204 5.204 0 0 0 3.651 1.49 5.204 5.204 0 0 0 3.65-1.49 5.057 5.057 0 0 0 1.517-3.604Zm-10.667 0a5.36 5.36 0 0 1 1.608-3.82 5.549 5.549 0 0 1 3.892-1.587c1.461 0 2.861.572 3.892 1.587A5.36 5.36 0 0 1 54 46.594a5.36 5.36 0 0 1-1.608 3.82A5.549 5.549 0 0 1 48.5 52a5.549 5.549 0 0 1-3.892-1.586A5.36 5.36 0 0 1 43 46.594Zm5.5-1.813a.508.508 0 0 1-.356-.144.476.476 0 0 1 0-.68.508.508 0 0 1 .712 0 .477.477 0 0 1 0 .68.508.508 0 0 1-.356.144Z"
      />
    </g>
    <defs>
      <clipPath id="b">
        <path fill="#fff" d="M30.5 30h24v24h-24z" />
      </clipPath>
      <filter
        id="a"
        width={84}
        height={84}
        x={0.5}
        y={0}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={10} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_10204_271004" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_10204_271004" result="shape" />
      </filter>
    </defs>
  </svg>
)
